<template>
  <main class="payment-page  container">
    <div class="payment-page__content  container-inner">
      <h1 class="payment-page__title">{{ $tPayment('Jobian Pay - profitable transfers') }}</h1>
      <div class="payment-page__description text" v-if="akord.request.status<4">
          <p>{{$tPayment('need_to_open')}}</p>
      </div>

      <div class="payment-page__main">
        <template v-if="akord.request.status<=1">
          <button v-if="akord.request.status===1" @click.prevent="accordEmulate">
            Эмулировать ответ банка
          </button><br><br>
          <PaymentAccountOpenCardAkord :requestData="akord.request"
                                       @after-open="onAfterOpenAkord"
                                       @after-cancel-open="onAfterOpenAkord"
                                       class="payment-page__open-card"/>
        </template>
        <template v-if="akord.request.status<=1">
          <PaymentAccountOpenCardSatchelPay disabled
                                            class="payment-page__open-card"/>
        </template>
        <template v-if="akord.request.status===2">
          <PaymentAccountOpenCardSatchelPay @refresh-status="refreshStatus" class="payment-page__open-card"/>
        </template>
        <template v-if="akord.request.status===3">
          <button v-if="akord.request.status===3" @click.prevent="satchelEmulate">
            Эмулировать ответ банка
          </button><br><br>
          <PaymentAccountOpenCardSatchelPay :requestSent="true"
                                            class="payment-page__open-card"/>
        </template>
        <template v-if="akord.request.status===4">
          <p>{{ $tPayment('From the account') }}:</p>
          <PaymentAccountCardSatchelPay :card="cardSatchel" class="payment-page__card"/>
        </template>
        <template v-if="akord.request.status>=2">
          <p v-if="akord.request.status===4">{{ $tPayment('On account') }}:</p>
          <p v-else>{{ $tPayment('Accounts are already open') }}:</p>
          <PaymentAccountCardAkord :requestData="akord.request" :card="cardAccord" class="payment-page__card"/>
        </template>

        <template v-if="akord.request.status===4">

            <div class="payment-transfer-page__input-section">
              <div class="payment-transfer-page__input-title">{{ $tPayment('Amount') }}:</div>
              <label class="payment-transfer-page__input-wrap">
                <input type="text"
                       :value="0"
                       name="amount"
                       ref="amount"
                       class="payment-transfer-page__input">
                <span class="payment-transfer-page__input-mark-text">EUR</span>
              </label>
            </div>
            <button @click="pay" class="payment-transfer-page__btn  base-btn  base-btn--green">
              <span>{{ $tPayment('Transfer') }}</span>
              <BaseSvg name="ico-arrow-light"
                       style="margin-left: 0.5rem"
                       width="0.5rem"
                       height="0.8rem"/>
            </button>

            <div class="payment-transfer-page__make-regular-wrap">
              <BaseCheckbox name="remember" ref="remember" @input="rememberChecked" :label="$tPayment('Remind me to pay next month')"
                            class="payment-transfer-page__make-regular"/>
            </div>
          <PaymentAccountRecurringPayments :reminds="reminds" class="payment-transfer-page__recurring-payments"/>
          <PaymentAccountHistory :history="history" class="payment-transfer-page__history" />
        </template>

        <!--<hr>
        <hr>
        <hr>
        <hr>


       <button @click.prevent="$vModal.open('payment-account-message', {
          text: `<p><b>Заявку відправлено!</b><br>
        Скоро з вами зв’яжеться співробітник банку Аккорд, а коли рахунок буде відкрито ― тут ви отримаєте всю
        інформацію по ньому
      </p>`
        })">
          Заявку відправлено!
        </button>

        <button @click.prevent="$vModal.open('payment-account-message', {
          text: `<p><b>Вітаємо!</b><br>
        Тепер вам може нараховуватись заробітня плата на європейський рахунок SatchelPay, з якого ви можете вивести кошти на власну картку Акордбанку. Нею ви можете вільно розраховуватись у магазині і т.д.
      </p>`
        })">
          Вітаємо!
        </button>

        <button @click.prevent="$vModal.open('payment-account-cancel-request', {
          onAccept: () => {}
         })">
          Скасувати заявку
        </button>

        <button @click.prevent="$vModal.open('payment-account-transfer-done', {
          text: `<p>Переказ <b>500.00 EUR</b> з рахунку <b>Satchel Рау (**** 6716)</b> було успішно відправпено на рахунок <b>Акккордбанк(****
        2345)</b>.
      </p>
      <p>
        Переказ було зроблено регулярним, наступний переказ: <b>14.04.2021 15:00</b>
      </p>`,
      onRejectRecurring: () => {}
         })">
          transfer-done
        </button>

        <button @click.prevent="$vModal.open('payment-account-requisites')">
          requisites
        </button>

        <PaymentAccountCardAkord class="payment-page__card"/>
        <PaymentAccountCardSatchelPay class="payment-page__card"/>

        <PaymentAccountOpenCardAkord @after-open="onAfterOpenAkord"
                                     @after-cancel-open="onAfterOpenAkord"
                                     class="payment-page__open-card"/>
        <PaymentAccountOpenCardAkord :requestData="{}"
                                     class="payment-page__open-card"/>
        <PaymentAccountOpenCardSatchelPay class="payment-page__open-card"/>
        <PaymentAccountOpenCardSatchelPay requestSent
                                          class="payment-page__open-card"/>
        <PaymentAccountOpenCardSatchelPay disabled
                                          class="payment-page__open-card"/>
          -->
      </div>

      <template v-if="akord.request.status<=3">
        <a href="#" class="payment-page__instruction-link  inline-link">{{ $tPayment('Step-by-step instructions') }}</a>
      </template>
    </div>
  </main>
</template>

<script>
  import '../../assets/less/style-account.less'
  import PaymentAccountOpenCardAkord from '@/components/payment/PaymentAccountOpenCardAkord'
  import PaymentAccountOpenCardSatchelPay from '@/components/payment/PaymentAccountOpenCardSatchelPay'
  import PaymentAccountCardAkord from '@/components/payment/PaymentAccountCardAkord'
  import PaymentAccountCardSatchelPay from '@/components/payment/PaymentAccountCardSatchelPay'
  import {http} from '@/axios'
  import PaymentAccountRecurringPayments from '@/components/payment/PaymentAccountRecurringPayments'
  import PaymentAccountHistory from '@/components/payment/PaymentAccountHistory'

  export default {
    name: 'PaymentAccountPage',
    components: {
      PaymentAccountOpenCardAkord,
      PaymentAccountOpenCardSatchelPay,
      PaymentAccountCardAkord,
      PaymentAccountCardSatchelPay,
      PaymentAccountRecurringPayments,
      PaymentAccountHistory,
    },
    data() {
      return {
        akord: {
          request: {
            status:0
          }
        },
        satchel: {
          request: {
            status:0
          }
        },
        remember_checked: 0,
        history: {},
        reminds: {},
        cardAccord: {},
        cardSatchel: {},
      }
    },
    methods: {
      onAfterOpenAkord(data) {
        this.akord.request = data
      },
      rememberChecked(data) {
        this.remember_checked = data;
      },
      updateCardAccord() {
        http.get('/api/jobian-pay/get-accord-balance')
                .then(({data}) => {
                  this.cardAccord = data
                })
      },
      updateCardSatchel() {
        http.get('/api/jobian-pay/get-jobian-pay-balance')
                .then(({data}) => {
                  this.cardSatchel = data
                })
      },
      load() {
        http.get('/api/jobian-pay/check-accord-order')
          .then(({data}) => {
            this.akord.request = data
            //this.akord.request = data.status ? data : null
          })
        this.getHistory()
        this.getReminds()
      },
      refreshStatus() {
        this.akord.request.status = 3;
        http.get('/api/jobian-pay/check-accord-order')
                .then(({data}) => {
                  this.akord.request = data
                  //this.akord.request = data.status ? data : null
                })
        this.updateCardAccord();
      },
      getHistory() {
        http.get('/api/jobian-pay/get-jobian-pay-history')
                .then(({data}) => {
                  this.history = data
                })
      },
      getReminds() {
        http.get('/api/jobian-pay/get-jobian-pay-reminds')
                .then(({data}) => {
                  this.reminds = data
                })
      },
      pay(){
        http.post('/api/jobian-pay/payment',{
          amount:this.$refs.amount.value,
          remember_checked:this.remember_checked,
        })
          .then(({data}) => {
            //console.log(data);
            if(data.status===1){
              let text = '<p>'+this.$tPayment('pay1')+' <b>'+data.data.amount+' EUR</b> '+this.$tPayment('pay2')+' <b>'+data.data.satchel_iban+'</b> '+this.$tPayment('pay3')+' <b>'+data.data.accord_iban+'</b>. </p>';
              if(data.data.remember_checked)
                  text += '<p>'+this.$tPayment('A reminder is set in a month')+'</p>';
              this.$vModal.open('payment-account-transfer-done', {
                text: text,
                //onRejectRecurring: () => {}
              })

              this.updateCardSatchel();
              this.updateCardAccord();

            }
            if(data.status===0){
              this.$vModal.open('payment-account-transfer-done', {
                text: '<p>'+this.$tPayment('No such account')+'</p>'
              })
            }
            if(data.status===2){
              this.$vModal.open('payment-account-transfer-done', {
                text: '<p>'+this.$tPayment('No balance')+'</p>'
              })
            }
            if(data.status===3){
              this.$vModal.open('payment-account-transfer-done', {
                text: '<p>'+this.$tPayment('Can`t pay')+'</p>'
              })
            }
            if(data.status===4){
              this.$vModal.open('payment-account-transfer-done', {
                text: '<p>'+this.$tPayment('No amount')+'</p>'
              })
            }
            this.getHistory()
            this.getReminds()
          })
      },
      accordEmulate(){
        http.get('/api/jobian-pay/accord-emulate')
                .then(({data}) => {
                  //this.reminds = data
                  if(data.status===1)
                    this.load()
                })
      },
      satchelEmulate(){
        http.get('/api/jobian-pay/satchel-emulate')
                .then(({data}) => {
                  //this.reminds = data
                  if(data.status===1)
                    this.load()
                })
      }
    },
    created() {
      this.load()
    }
  }
</script>

<style lang="less">

</style>
